module.exports = __webpack_public_path__ + "static/media/highways-england-logo-charcoal.d416985b.svg";